'use client';

import { useRouter, useSearchParams } from 'next/navigation';

import { SortSelect } from '../sort-select/sort-select';

import styles from './search-results.module.scss';

export default function SearchSort() {
  const router = useRouter();
  const searchParams = useSearchParams();

  return (
    <SortSelect
      current={searchParams.get('sort') || undefined}
      onSortChange={(sort) => {
        const newSearchParams = new URLSearchParams({
          ...Object.fromEntries(searchParams),
          page: '1',
          sort: sort.value,
        });

        router.replace(`?${newSearchParams.toString()}`);
      }}
      overlayClassName={styles.sortByMenu}
    />
  );
}
